export const enum SwitchTextPosition {
    Left = 'left',
    Right = 'right'
};
